import * as React from 'react';

const useInterval = (
  cb: () => { clear: boolean },
  ms: number,
  maxms?: number
) => {
  const timerRef = React.useRef<any>();
  const timer = React.useRef<number>(0);

  React.useLayoutEffect(() => {
    timerRef.current = setInterval(() => {
      if (maxms) {
        timer.current += ms;
        if (timer.current >= maxms) {
          clearTimeout(timerRef.current);
        }
      }

      if (typeof cb === 'function') {
        const { clear } = cb();
        if (clear) {
          clearTimeout(timerRef.current);
        }
      }
    }, ms);

    return () => {
      clearInterval(timerRef.current);
    };
  }, []);
};

interface IUseInlineLinkArgs {
  targetId: string;
  onClick: () => void;
}

export const useInlineLink = (args: IUseInlineLinkArgs) => {
  const [linkElement, setLinkElement] = React.useState<HTMLElement | null>(
    null
  );
  if (typeof window !== 'undefined') {
    useInterval(
      () => {
        if (linkElement) {
          return { clear: true };
        } else {
          const link = document.getElementById(args.targetId);
          if (link) {
            setLinkElement(link);
            return { clear: true };
          }
        }
        return { clear: false };
      },
      500,
      2000
    );
  }

  if (typeof window !== 'undefined') {
    React.useLayoutEffect(() => {
      if (linkElement) {
        linkElement.addEventListener('click', args.onClick);
      }
      return () => {
        if (linkElement) {
          removeEventListener('click', args.onClick);
        }
      };
    }, [linkElement]);
  }
};
